const CartAnimActionTypes = {
    CART_ANIM_START: "CART_ANIM_START",
    CART_ANIM_END: "CART_ANIM_END",
  };
  
  export default CartAnimActionTypes;
  